export default __webpack_public_path__ + "static/eyes_of_the_sun_green-b665592f28d9e6135dbf77a2376a2e03.png";